export class WorkOrderType {
  constructor(description?: string, workOrderTypeId?: string, cosim?: number) {
    this.description = description;
    this.workOrderTypeId = workOrderTypeId;
    this.cosim = cosim;
  }

  description: string;
  workOrderTypeId: string;
  cosim: number;
}
